import { createContext } from "react";

import { NativeTransport } from "domains/native/types";

export const NativeTransportContext = createContext<NativeTransport | null>(
    null,
);
